const CONTAINER_ID = 'toast';
const ALLOWED_TYPES = ['success', 'error', 'warning', 'info'];

function getContainer() {
  return document.getElementById(CONTAINER_ID) || (() => {
    const el = document.createElement('div');
    el.id = CONTAINER_ID;
    document.body.appendChild(el);
    return el;
  })();
}

export function showToast(type, message, title = null) {
  if (!ALLOWED_TYPES.includes(type)) return;

  const template = document.getElementById(`toast-template-${type}`);
  if (!template) return;

  clearToasts();
  const clone = template.content.cloneNode(true);

  const messageEl = clone.querySelector('[data-toast-target="message"]');
  if (typeof message === 'string') {
    messageEl.textContent = message;
  } else {
    messageEl.replaceChildren(message);
  }

  if (title) {
    const titleEl = clone.querySelector('[data-toast-target="title"]');
    titleEl.textContent = title;
    titleEl.removeAttribute('hidden');
    clone.querySelector('.toast').classList.replace('align-items-center', 'align-items-start');
  }

  getContainer().append(clone);
}

export function clearToasts() {
  document.getElementById(CONTAINER_ID)?.replaceChildren();
}

document.addEventListener('turbo:before-cache', clearToasts);

window.showToast = showToast;
